import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GeneralResponse } from 'app/models/general-response.model';
import { environment } from 'environments/environment';
import { catchError, Observable, of, ReplaySubject, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PlateService {
    /**
     * Objects
     */
    private _plates: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);

    /**
     * Constructord
     * @param _http
     */
    constructor(private _http: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * getter for farms
     */
    get plates$(): Observable<string[]> {
        return this._plates.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // Private methods
    // -----------------------------------------------------------------------------------------------------

    // -----------------------------------------------------------------------------------------------------
    // Public methods
    // -----------------------------------------------------------------------------------------------------

    getPlates(): Observable<GeneralResponse> {
        return this._http
            .get<GeneralResponse>(
                `${environment.backendURL}${environment.PlateListURL}`
            )
            .pipe(
                tap((plates) => {
                    this._plates.next(plates.workload);
                }),
                catchError((err) => {
                    let customResponse = {
                        code: err.status,
                        msg: 'Could not load data',
                    } as GeneralResponse;
                    return of(customResponse);
                })
            );
    }
}
